import { CoreSpaceFunction } from '@densityco/lib-api-types';

export const SPACE_FUNCTION_DISPLAY_NAMES = {
  [CoreSpaceFunction.BREAK_ROOM]: 'Break Room',
  [CoreSpaceFunction.CAFE]: 'Cafe',
  [CoreSpaceFunction.COLLABORATION]: 'Collaboration Room',
  [CoreSpaceFunction.CONFERENCE_ROOM]: 'Conference Room',
  [CoreSpaceFunction.DINING_AREA]: 'Dining Area',
  [CoreSpaceFunction.EVENT_SPACE]: 'Event Space',
  [CoreSpaceFunction.FOCUS_QUIET]: 'Focus / Quiet Room',
  [CoreSpaceFunction.GYM]: 'Gym',
  [CoreSpaceFunction.KITCHEN]: 'Kitchen',
  [CoreSpaceFunction.LAB]: 'Lab',
  [CoreSpaceFunction.LIBRARY]: 'Library',
  [CoreSpaceFunction.LOUNGE]: 'Lounge',
  [CoreSpaceFunction.MEETING_ROOM]: 'Meeting Room',
  [CoreSpaceFunction.OFFICE]: 'Office',
  [CoreSpaceFunction.PHONE_BOOTH]: 'Phone Booth',
  [CoreSpaceFunction.PLACE_OF_WORSHIP]: 'Place of Worship',
  [CoreSpaceFunction.RECEPTION]: 'Reception',
  [CoreSpaceFunction.RESTROOM]: 'Restroom',
  [CoreSpaceFunction.RETAIL]: 'Retail',
  [CoreSpaceFunction.THEATER]: 'Theater',
  [CoreSpaceFunction.WELLNESS_ROOM]: 'Wellness Room',
  [CoreSpaceFunction.WORKSTATIONS]: 'Workstations',
};

export const SPACE_FUNCTION_CHOICES: Array<{ id: string | null; label: string }> = Object.keys(SPACE_FUNCTION_DISPLAY_NAMES).map(
  (id) => ({ id, label: SPACE_FUNCTION_DISPLAY_NAMES[id as CoreSpaceFunction] })
);
SPACE_FUNCTION_CHOICES.push({ id: null, label: 'Other' });

export function formatSpaceFunction(spaceFunction: CoreSpaceFunction): string {
  return SPACE_FUNCTION_DISPLAY_NAMES[spaceFunction] || spaceFunction || 'Other';
}
